import { Divider } from "@redotech/redo-web/arbiter-components/divider/divider";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import * as styles from "./ask-redo-handoff-divider.module.css";

export const AskRedoHandoffDivider = memo(function AskRedoHandoffDivider({
  agentName,
}: {
  agentName: string | null;
}) {
  return (
    <Flex align="center" aria-label="Conversation handoff" gap="sm" w="full">
      <Divider classes={styles.divider} />
      <Flex className={styles.content}>
        <Text fontSize="xs" textColor="secondary">
          {`Conversation handed off to ${agentName ?? "Support"}`}
        </Text>
      </Flex>
      <Divider classes={styles.divider} />
    </Flex>
  );
});
